import React from "react";

const AppML_Case_Intro = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Intro</h1>
      <p>This is the AppML Case Intro page content.</p>
    </div>
  );
};

export default AppML_Case_Intro;
